import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Collapse from "@material-ui/core/Collapse";
import clsx from "clsx";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import HazmatForm from "./HazmatForm";

const styles = (theme) => ({
  card: {
    marginBottom: 4,
    overflow: "inherit",
    backgroundColor: theme.ModalBGColor,
  },
  title: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
  },
  subheader: {
    color: theme.hazmatSubheader,
    fontSize: theme.textFontSize,
  },
  closeIcon: {
    color: theme.iconColor,
  },
  headerRoot: {
    padding: 8,
    borderBottom: `1px solid ${theme.gridIconBorderColor}`,
  },
  editIcon: {
    marginTop: 8,
  },
  titleRow: {
    display: "flex",
    width: "30%",
    justifyContent: "space-between",
  },
  numberStyle: {
    fontSize: theme.headerTextFontSize,
  },
});
class HazmatCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }
  handleEditClick = () => {
    const { handleHazmatEdit } = this.props;
    this.setState({ expanded: true });
    handleHazmatEdit && handleHazmatEdit();
  };

  handleHazmatChange = (name) => (value) => {
    const { handleHazmatChange, index } = this.props;
    handleHazmatChange(name, index)(value);
  };

  handleHazmatCardDelete = () => {
    const { handleHazmatCardDelete, index } = this.props;
    handleHazmatCardDelete(index);
  };
  closeHazmatForm = () => {
    this.setState({
      expanded: false,
    });
    this.props.closeHazmatForm();
  };
  saveHazmatEntry = (hazmatDetails) => {
    this.setState({
      expanded: false,
    });
    this.props.saveHazmatEntry(
      hazmatDetails,
      this.props.index,
      "updateCardForm"
    );
  };

  getPackageType = (packageCode) => {
    return this.props.packageTypeList.find(
      (packageType) => packageType.value === packageCode
    );
  };

  render() {
    const { hazmatInfo, classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: classes.title,
            subheader: classes.subheader,
            root: classes.headerRoot,
          }}
          action={
            !this.state.expanded && (
              <div>
                <IconButton
                  aria-label="edit"
                  className={`${clsx(classes.expand, {
                    [classes.expandOpen]: this.state.expanded,
                  })} ${classes.editIcon}`}
                  onClick={this.handleEditClick}
                  aria-expanded={this.state.expanded}
                >
                  <EditIcon className={classes.closeIcon} />
                </IconButton>
                <IconButton
                  aria-label="edit"
                  className={`${clsx(classes.expand, {
                    [classes.expandOpen]: this.state.expanded,
                  })} ${classes.editIcon}`}
                  onClick={this.handleHazmatCardDelete}
                  aria-expanded={this.state.expanded}
                >
                  <DeleteOutlineIcon className={classes.closeIcon} />
                </IconButton>
              </div>
            )
          }
          title={
            <div className={classes.titleRow}>
              <div>{hazmatInfo?.unNumber}</div>
              <div>{"PG " + hazmatInfo?.pgNumber}</div>
            </div>
          }
          subheader={
            <div>
              <p>
                <span className={classes.numberStyle}>
                  {hazmatInfo?.pieces}
                </span>
                {this.getPackageType(hazmatInfo?.packageCode)?.label}
              </p>
              <p>
                <span className={classes.numberStyle}>
                  {hazmatInfo?.weight}
                </span>
                LBS
              </p>
            </div>
          }
        />
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <HazmatForm
              saveHazmatEntry={this.saveHazmatEntry}
              handleHazmatChange={this.handleHazmatChange}
              hazmatInfo={hazmatInfo}
              closeHazmatForm={this.closeHazmatForm}
              packageWeight={this.props.packageWeight}
              totalHazmatWeight={this.props.totalHazmatWeight}
            />
          </CardContent>
        </Collapse>
      </Card>
    );
  }
}

export default withStyles(styles)(HazmatCard);
